export const formatTimePart = (value) => String(value).padStart(2, '0');

export const formatFullTime = ({ hours, minutes }) => `${formatTimePart(hours)}:${formatTimePart(minutes)}`;

export const getCurrentTime = (offsetHours = 0) => {
  const currentDate = new Date();

  let hours = currentDate.getHours();
  let minutes = currentDate.getMinutes();

  hours = (hours + offsetHours + 24) % 24;

  return `${formatTimePart(hours)}:${formatTimePart(minutes)}`;
};

export const getNearestAvailableTime = (time, timeLimits) => {
  if (typeof time !== 'string') {
    console.error('Incorrect time format:', time);
    throw new Error('Time parameter must be a string in format "HH:MM"');
  }

  const [inputHours, inputMinutes] = time.split(':').map(Number);

  if (isNaN(inputHours) || isNaN(inputMinutes)) {
    console.error('Incorrect value of hours or minutes in:', time);
    throw new Error('Hours and minutes must be numbers in format "HH:MM"');
  }

  const isEndTime = timeLimits.maxHours === 22;

  const getMinMinutes = (hours) => {
    if (isEndTime && hours === 9) return 15;
    return timeLimits.minMinutes;
  };

  const getMaxMinutes = (hours) => {
    if (isEndTime && hours === 22) return 0;
    if (!isEndTime && hours === 21) return 45;
    return 59;
  };

  const effectiveMinMinutes = getMinMinutes(inputHours);
  if (inputHours < timeLimits.minHours || (inputHours === timeLimits.minHours && inputMinutes < effectiveMinMinutes)) {
    return { hours: timeLimits.minHours, minutes: getMinMinutes(timeLimits.minHours) };
  }

  const effectiveMaxMinutes = getMaxMinutes(inputHours);
  if (inputHours > timeLimits.maxHours || (inputHours === timeLimits.maxHours && inputMinutes > effectiveMaxMinutes)) {
    return { hours: timeLimits.maxHours, minutes: getMaxMinutes(timeLimits.maxHours) };
  }

  const roundedMinutes = Math.round(inputMinutes / 15) * 15;
  let adjustedHours = inputHours;
  let adjustedMinutes = roundedMinutes;

  if (roundedMinutes === 60) {
    adjustedMinutes = 0;
    adjustedHours = inputHours + 1;

    if (adjustedHours > timeLimits.maxHours) {
      adjustedHours = timeLimits.maxHours;
      adjustedMinutes = getMaxMinutes(timeLimits.maxHours);
    }
  }

  const finalMinMinutes = getMinMinutes(adjustedHours);
  const finalMaxMinutes = getMaxMinutes(adjustedHours);

  if (adjustedMinutes < finalMinMinutes) {
    adjustedMinutes = finalMinMinutes;
  }
  if (adjustedMinutes > finalMaxMinutes) {
    adjustedMinutes = finalMaxMinutes;
  }

  return { hours: adjustedHours, minutes: adjustedMinutes };
};
